
import { mapActions } from "vuex";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-clientes-lista",
  mixins: [SistemaMixin],
  data() {
    return {
      clientes: [],
      revenda: {},
      totalClientes: 0,
      busca: "",
      filtroRapido: "todos",
      clienteAppsSelecionado: null,
      clienteAppsGestao: null,
      loadingAppsClienteGestao: false,
      salvandoAppsClienteGestao: false,
      featuresGestaoCliente: [],
      saldoAppsRevenda: {
        disponivel: 0,
        usado: 0,
      },
      licencasMultiempresaDisponiveis: 0,
      opcoesPeriodoMeses: [
        { value: 1, text: "1" },
        { value: 3, text: "3" },
        { value: 6, text: "6" },
        { value: 12, text: "12" },
        { value: 24, text: "24" },
      ],
      filtrosRapidos: [
        { value: "todos", text: "Todos" },
        { value: "ativos", text: "Ativos" },
        { value: "bloqueados", text: "Bloqueados" },
        { value: "com_apps", text: "Com apps" },
        { value: "sem_apps", text: "Sem apps" },
      ],
    };
  },
  async mounted() {
    await this.getDataInit();
  },
  methods: {
    ...mapActions(["setLoading"]),
    normalizarFeatureGestaoCliente(feature) {
      const cadastro = feature.feature || {};
      const billingMode = feature.billing_mode || cadastro.billing_mode || "flat";
      const minQuantity = Math.max(
        1,
        Number(feature.min_quantity || cadastro.min_quantity || 1)
      );
      const maxQuantity = Math.max(
        minQuantity,
        Number(feature.max_quantity || cadastro.max_quantity || 99)
      );

      return {
        code: feature.code || cadastro.code,
        name: feature.name || feature.nome || cadastro.name || cadastro.nome || "App",
        type: String(feature.type || feature.tipo || cadastro.type || "module").toLowerCase() === "plugin"
          ? "plugin"
          : "module",
        billing_mode: billingMode,
        monthly_price: this.valorNumericoLicenca(
          feature.monthly_price ??
            feature.valor_mensal ??
            cadastro.monthly_price ??
            cadastro.valor_mensal ??
            0
        ),
        active: this.valorBooleano(
          feature.active ?? feature.ativo ?? feature.enabled ?? feature.liberado
        ),
        quantity:
          billingMode === "per_quantity"
            ? Math.max(minQuantity, Number(feature.quantity || feature.quantidade || 1))
            : 1,
        months: Math.max(1, Number(feature.months || feature.meses || 12)),
        min_quantity: minQuantity,
        max_quantity: maxQuantity,
        originalActive: this.valorBooleano(
          feature.active ?? feature.ativo ?? feature.enabled ?? feature.liberado
        ),
        originalQuantity:
          billingMode === "per_quantity"
            ? Math.max(minQuantity, Number(feature.quantity || 1))
            : 1,
      };
    },
    quantidadeFeatureGestao(feature) {
      const minimo = Math.max(1, Number(feature.min_quantity || 1));
      const maximo = Math.max(minimo, Number(feature.max_quantity || 99));

      return Math.min(
        maximo,
        Math.max(minimo, Number(feature.quantity || minimo))
      );
    },
    totalFeatureGestao(feature) {
      if (!feature.active) return 0;

      const quantidade =
        feature.billing_mode === "per_quantity"
          ? this.quantidadeFeatureGestao(feature)
          : 1;
      const meses = Math.max(1, Number(feature.months || 12));

      return this.valorNumericoLicenca(feature.monthly_price) * quantidade * meses;
    },
    async carregarSaldoAppsRevenda() {
      const idRevenda = this.$route.params.id_revenda;
      if (!idRevenda) return;

      try {
        let response;

        try {
          response = await this.$http.get(`/api/revenda/${idRevenda}/apps/saldo`);
        } catch (e) {
          response = await this.$http.post(`/api/revenda/apps/saldo`, {
            id_revenda: idRevenda,
          });
        }

        const data = response?.data?.data ?? response?.data ?? {};
        this.licencasMultiempresaDisponiveis = Math.max(
          0,
          Number(data.wallet?.licencas_disponiveis || 0)
        );
        this.saldoAppsRevenda = {
          disponivel: this.valorNumericoLicenca(
            data.saldo_disponivel ?? data.disponivel ?? data.available ?? 0
          ),
          usado: this.valorNumericoLicenca(
            data.saldo_usado ?? data.usado ?? data.used ?? 0
          ),
        };
      } catch (e) {
        this.$toast.error("Erro ao carregar saldo de apps da revenda.");
      }
    },
    async abrirGestaoAppsCliente(cliente) {
      const idRevendaRota = Number(this.$route.params.id_revenda);
      const idRevendaCliente = Number(cliente?.id_revenda || idRevendaRota);

      if (idRevendaRota && idRevendaCliente && idRevendaRota !== idRevendaCliente) {
        this.$toast.error("Não é permitido liberar apps para cliente de outra revenda.");
        return;
      }

      this.clienteAppsGestao = cliente;
      this.loadingAppsClienteGestao = true;
      this.featuresGestaoCliente = [];
      this.$bvModal.show("modal-gestao-apps-cliente-revenda");

      try {
        await this.carregarSaldoAppsRevenda();
        const response = await this.$http.get(
          `/api/revenda/clientes/${cliente.id_empresa}/features`
        );
        const data = response?.data?.data ?? response?.data ?? {};
        const features = Array.isArray(data) ? data : data.features || data.items || [];

        this.featuresGestaoCliente = features
          .map((item) => this.normalizarFeatureGestaoCliente(item))
          .filter((item) => item.code);
      } catch (e) {
        this.$toast.error("Erro ao carregar apps do cliente.");
      } finally {
        this.loadingAppsClienteGestao = false;
      }
    },
    async salvarAppsClienteGestao() {
      if (!this.clienteAppsGestao?.id_empresa) return;

      const totalConsumo = this.totalConsumoAppsGestao;
      if (totalConsumo > this.saldoAppsRevenda.disponivel) {
        this.$toast.error(
          "Saldo insuficiente para liberar estes apps. Solicite mais créditos à Nuts."
        );
        return;
      }
      if (
        this.consumoLicencasMultiempresa >
        this.licencasMultiempresaDisponiveis
      ) {
        this.$toast.error(
          "Estoque de licenças insuficiente para o limite Multiempresa informado."
        );
        return;
      }

      this.salvandoAppsClienteGestao = true;
      try {
        const payload = {
          features: this.featuresGestaoCliente
            .filter((feature) => feature.code)
            .map((feature) => ({
              code: feature.code,
              active: Boolean(feature.active),
              quantity:
                feature.billing_mode === "per_quantity"
                  ? this.quantidadeFeatureGestao(feature)
                  : 1,
              months: Math.max(1, Number(feature.months || 12)),
            })),
        };

        await this.$http.put(
          `/api/revenda/clientes/${this.clienteAppsGestao.id_empresa}/features`,
          payload
        );

        this.$toast.success("Apps do cliente atualizados com sucesso!");
        this.$bvModal.hide("modal-gestao-apps-cliente-revenda");
        await this.getDataInit();
      } catch (e) {
        this.$toast.error(
          e?.response?.data?.message || "Erro ao salvar apps do cliente."
        );
      } finally {
        this.salvandoAppsClienteGestao = false;
      }
    },
    async getDataInit() {
      this.setLoading(true);

      try {
        const id = this.$route.params.id_revenda;
        const resposta = await this.getClientesByRevenda(id);
        const clientes = resposta?.clientes || [];

        this.clientes = clientes;
        this.totalClientes = resposta?.total ?? clientes.length;
        this.revenda = this.normalizarRevenda(resposta, clientes[0]);

        if (!clientes.length) {
          this.$toast.warning("Nenhum cliente vinculado a revenda!");
        }
      } catch (e) {
        this.$toast.error("Erro ao carregar clientes da revenda.");
      } finally {
        this.setLoading(false);
      }
    },
    normalizarRevenda(resposta, primeiroCliente) {
      const revenda = resposta?.revenda || {};
      const origem = primeiroCliente || {};

      return {
        nome: revenda.nome || origem.revenda_nome || null,
        fone: revenda.fone || origem.revenda_fone || null,
        uf: revenda.uf || origem.revenda_uf || null,
        cidade: revenda.cidade || origem.revenda_cidade || null,
        cep: revenda.cep || origem.revenda_cep || null,
        logradouro: revenda.logradouro || origem.revenda_logradouro || null,
        numero: revenda.numero || origem.revenda_numero || null,
        bairro: revenda.bairro || origem.revenda_bairro || null,
      };
    },
    clienteKey(cliente) {
      return cliente.id_empresa || cliente.cnpj || cliente.cliente;
    },
    cidadeUfCliente(cliente) {
      const cidade = cliente.empresa_cidade || cliente.cliente_cidade || cliente.cidade;
      const uf = cliente.empresa_uf || cliente.cliente_uf || cliente.uf;

      if (cidade && uf) return `${cidade} - ${uf}`;
      return cidade || uf || "Cidade não informada";
    },
    documentoCliente(cliente) {
      if (!cliente.cnpj) return "Não informado";

      try {
        return this.formatCpfCnpj(cliente.cnpj);
      } catch (e) {
        return cliente.cnpj;
      }
    },
    valorBooleano(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value === "string") {
        return ["1", "true", "sim", "yes", "ativo", "bloqueado"].includes(
          value.toLowerCase()
        );
      }

      return false;
    },
    clienteAtivo(cliente) {
      return this.valorBooleano(cliente.status);
    },
    clienteBloqueado(cliente) {
      return this.valorBooleano(cliente.bloqueado);
    },
    formatarDataLista(data) {
      return data ? this.formatDate(data) : "Não informada";
    },
    resumoLicenca(row) {
      const resumo = row?.licenca_resumo || {};
      const plano = resumo.plano || {};
      const apps = resumo.apps || {};
      const totais = resumo.totais || {};
      const itensApps = Array.isArray(apps.itens) ? apps.itens : [];
      const valorPlanoResumo = this.valorNumericoLicenca(plano.valor_anual);
      const valorPlanoBase = this.valorNumericoLicenca(
        plano.base_valor_anual ?? resumo.plano_valor_anual ?? row?.valor ?? 0
      );
      const totalAnualApps = this.valorNumericoLicenca(apps.anual_total ?? 0);
      const totalMensalApps = this.valorNumericoLicenca(apps.mensal_total ?? 0);
      const totalAnualResumo = this.valorNumericoLicenca(
        totais.total_anual_licenca
      );
      const resumoInconsistente =
        valorPlanoResumo > 0 &&
        totalAnualResumo > 0 &&
        Math.abs(valorPlanoResumo + totalAnualApps - totalAnualResumo) > 0.01;
      const valorPlanoAnual =
        resumoInconsistente && valorPlanoBase > 0
          ? valorPlanoBase
          : valorPlanoResumo || valorPlanoBase;
      const totalAnualCalculado = valorPlanoAnual + totalAnualApps;
      const totalAtivos =
        Number(apps.total_ativos || 0) ||
        itensApps.filter((item) => this.appLicencaAtivo(item)).length;

      return {
        plano: {
          nome:
            plano.nome ||
            row?.plano ||
            row?.nome_plano ||
            this.obterNomePlanoLicenca(row?.id_plan),
          valor_anual: valorPlanoAnual,
          data_validade: plano.data_validade || row?.data_validade || null,
        },
        apps: {
          total_ativos: totalAtivos,
          anual_total: totalAnualApps,
          mensal_total: totalMensalApps,
          itens: itensApps,
        },
        totais: {
          total_anual_licenca:
            totalAnualResumo > 0 &&
            Math.abs(totalAnualResumo - totalAnualCalculado) <= 0.01
              ? totalAnualResumo
              : totalAnualCalculado,
          total_mensal_recorrente: this.valorNumericoLicenca(
            totais.total_mensal_recorrente ?? totalMensalApps
          ),
        },
      };
    },
    appLicencaAtivo(item) {
      const valor = item?.active ?? item?.ativo ?? item?.enabled ?? item?.liberado;

      if (typeof valor === "boolean") return valor;
      if (typeof valor === "number") return valor === 1;
      if (typeof valor === "string") {
        return ["1", "true", "sim", "yes", "ativo"].includes(valor.toLowerCase());
      }

      return true;
    },
    valorNumericoLicenca(valor) {
      if (valor === null || valor === undefined || valor === "") return 0;
      if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;

      const normalizado = String(valor)
        .replace(/[^\d,.-]/g, "")
        .replace(/\.(?=\d{3}(,|$))/g, "")
        .replace(",", ".");
      const numero = Number(normalizado);

      return Number.isFinite(numero) ? numero : 0;
    },
    primeiroValorNumericoLicenca(...valores) {
      for (const valor of valores) {
        const numero = this.valorNumericoLicenca(valor);
        if (numero > 0) return numero;
      }

      return 0;
    },
    formatarMoedaLicenca(valor) {
      return `R$ ${this.numberToReal(this.valorNumericoLicenca(valor), 2)}`;
    },
    obterNomePlanoLicenca(idPlan) {
      const planos = {
        1: "Free",
        2: "Essencial Anual",
        3: "Essencial Mensal",
        4: "Standard Mensal",
        6: "Standard Anual",
        7: "Basic",
      };

      return planos[Number(idPlan)] || "Sem plano";
    },
    nomePlanoLicenca(row) {
      return this.resumoLicenca(row).plano.nome || "Sem plano";
    },
    dataValidadeLicenca(row) {
      return this.resumoLicenca(row).plano.data_validade;
    },
    totalAppsAtivosLicenca(row) {
      return this.resumoLicenca(row).apps.total_ativos;
    },
    totalAnualAppsLicenca(row) {
      return this.resumoLicenca(row).apps.anual_total;
    },
    totalMensalAppsLicenca(row) {
      return this.resumoLicenca(row).apps.mensal_total;
    },
    totalAnualLicenca(row) {
      return this.resumoLicenca(row).totais.total_anual_licenca;
    },
    totalMensalRecorrenteLicenca(row) {
      return this.resumoLicenca(row).totais.total_mensal_recorrente;
    },
    appsAtivosLicenca(row) {
      return this.resumoLicenca(row).apps.itens.filter((item) =>
        this.appLicencaAtivo(item)
      );
    },
    nomeAppLicenca(app) {
      return (
        app.nome ||
        app.name ||
        app.titulo ||
        app.title ||
        app.codigo ||
        app.code ||
        "App"
      );
    },
    tipoAppLicenca(app) {
      const tipo = app.tipo || app.type || app.categoria || "Módulo";
      return String(tipo).toLowerCase() === "plugin" ? "Plugin" : "Módulo";
    },
    origemAppLicenca(app) {
      const origem = app.origem || app.source || app.renewal_origin;
      const nomes = {
        renewal: "Renovação",
        marketplace: "Marketplace",
        checkout: "Marketplace",
        manual: "Manual",
        legacy: "Legado",
        revenda: "Revenda",
      };

      return nomes[origem] || origem || "Não informada";
    },
    textoValorAppLicenca(app) {
      const valorAnual = this.primeiroValorNumericoLicenca(
        app.valor_anual,
        app.anual_total,
        app.total_anual,
        app.annual_price
      );
      const valorMensalUnitario = this.primeiroValorNumericoLicenca(
        app.valor_mensal,
        app.monthly_price
      );
      const valorMensalTotal = this.primeiroValorNumericoLicenca(
        app.mensal_total,
        app.total_mensal,
        valorMensalUnitario
      );
      const quantidade = Number(app.quantidade || app.quantity || 0);
      const valores = [];

      if (valorAnual > 0) {
        valores.push(`${this.formatarMoedaLicenca(valorAnual)}/ano`);
      }

      if (valorMensalTotal > 0) {
        if (
          quantidade > 1 &&
          valorMensalUnitario > 0 &&
          valorMensalTotal !== valorMensalUnitario
        ) {
          valores.push(
            `${quantidade} x ${this.formatarMoedaLicenca(
              valorMensalUnitario
            )} = ${this.formatarMoedaLicenca(valorMensalTotal)}/mês`
          );
        } else {
          valores.push(`${this.formatarMoedaLicenca(valorMensalTotal)}/mês`);
        }
      }

      return valores.length ? valores.join(" + ") : "Sem valor informado";
    },
    nomesAppsResumo(row) {
      const apps = this.appsAtivosLicenca(row);
      if (!apps.length) return "Detalhes dos apps não enviados";

      const nomes = apps.slice(0, 3).map((app) => this.nomeAppLicenca(app));
      const restante = apps.length - nomes.length;
      const sufixo = restante > 0 ? ` +${restante} apps` : "";

      return `${nomes.join(", ")}${sufixo}`;
    },
    abrirModalApps(cliente) {
      this.clienteAppsSelecionado = cliente;
      this.$bvModal.show("modal-apps-cliente-revenda");
    },
    textoBuscaCliente(cliente) {
      const apps = this.appsAtivosLicenca(cliente)
        .map((app) => this.nomeAppLicenca(app))
        .join(" ");

      return [
        cliente.cliente,
        cliente.cnpj,
        cliente.fone,
        cliente.empresa_cidade,
        cliente.cliente_cidade,
        cliente.cidade,
        cliente.empresa_uf,
        cliente.cliente_uf,
        cliente.uf,
        apps,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
  },
  computed: {
    enderecoRevenda() {
      const partes = [
        this.revenda.logradouro,
        this.revenda.numero,
        this.revenda.bairro,
        this.revenda.cep,
        this.revenda.cidade && this.revenda.uf
          ? `${this.revenda.cidade} - ${this.revenda.uf}`
          : this.revenda.cidade || this.revenda.uf,
      ].filter(Boolean);

      return partes.length ? partes.join(", ") : "Não informado";
    },
    metricas() {
      return {
        total: this.totalClientes || this.clientes.length,
        ativos: this.clientes.filter((cliente) => this.clienteAtivo(cliente)).length,
        bloqueados: this.clientes.filter((cliente) =>
          this.clienteBloqueado(cliente)
        ).length,
        comApps: this.clientes.filter(
          (cliente) => this.totalAppsAtivosLicenca(cliente) > 0
        ).length,
      };
    },
    clientesFiltrados() {
      const termo = this.busca
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

      return this.clientes.filter((cliente) => {
        const totalApps = this.totalAppsAtivosLicenca(cliente);

        if (this.filtroRapido === "ativos" && !this.clienteAtivo(cliente)) {
          return false;
        }
        if (
          this.filtroRapido === "bloqueados" &&
          !this.clienteBloqueado(cliente)
        ) {
          return false;
        }
        if (this.filtroRapido === "com_apps" && totalApps <= 0) return false;
        if (this.filtroRapido === "sem_apps" && totalApps > 0) return false;
        if (
          this.filtroRapido === "apps_mensais" &&
          this.totalMensalAppsLicenca(cliente) <= 0
        ) {
          return false;
        }
        if (
          this.filtroRapido === "apps_anuais" &&
          this.totalAnualAppsLicenca(cliente) <= 0
        ) {
          return false;
        }

        if (!termo) return true;

        return this.textoBuscaCliente(cliente).includes(termo);
      });
    },
    appsClienteSelecionado() {
      if (!this.clienteAppsSelecionado) return [];
      return this.appsAtivosLicenca(this.clienteAppsSelecionado);
    },
    totalConsumoAppsGestao() {
      return this.featuresGestaoCliente.reduce(
        (acc, feature) => acc + this.totalFeatureGestao(feature),
        0
      );
    },
    saldoRestanteAppsGestao() {
      return Math.max(0, this.saldoAppsRevenda.disponivel - this.totalConsumoAppsGestao);
    },
    consumoLicencasMultiempresa() {
      const feature = this.featuresGestaoCliente.find(
        (item) => item.code === "PLG_MULTIEMPRESA"
      );
      if (!feature || !feature.active) return 0;

      const quantidade = this.quantidadeFeatureGestao(feature);

      return feature.originalActive
        ? Math.max(0, quantidade - Number(feature.originalQuantity || 0))
        : quantidade;
    },
    devolucaoLicencasMultiempresa() {
      const feature = this.featuresGestaoCliente.find(
        (item) => item.code === "PLG_MULTIEMPRESA"
      );
      if (!feature || !feature.active || !feature.originalActive) return 0;

      return Math.max(
        0,
        Number(feature.originalQuantity || 0) -
          this.quantidadeFeatureGestao(feature)
      );
    },
    saldoLicencasMultiempresa() {
      return Math.max(
        0,
        this.licencasMultiempresaDisponiveis -
          this.consumoLicencasMultiempresa +
          this.devolucaoLicencasMultiempresa
      );
    },
  },
};
